import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataOptions, Option } from '../../types/user';
import { RootState } from '..';
import { transformToDropdownOptions } from '../../constant/utils/transformToDropdownOptions';

const initialState: DataOptions = {
  genderOptions: {
    _id: '',
    selections: {},
  },
  pronounOptions: {
    _id: '',
    selections: {},
  },
  ethnicityOptions: {
    _id: '',
    selections: {},
  },
  sexualOrientationOptions: {
    _id: '',
    selections: {},
  },
};

export const demographicSlice = createSlice({
  name: 'demographic',
  initialState,
  reducers: {
    updateGenderOptions: (state, action: PayloadAction<Option>) => {
      return {
        ...state,
        genderOptions: action.payload,
      };
    },
    updatePronounOptions: (state, action: PayloadAction<Option>) => {
      return {
        ...state,
        pronounOptions: action.payload,
      };
    },
    updateEthnicityOptions: (state, action: PayloadAction<Option>) => {
      return {
        ...state,
        ethnicityOptions: action.payload,
      };
    },
    updateSexualOrientationOptions: (state, action: PayloadAction<Option>) => {
      return {
        ...state,
        sexualOrientationOptions: action.payload,
      };
    },
    clearDemographicOptions: () => initialState,
  },
});

export const {
  updateGenderOptions,
  updatePronounOptions,
  updateEthnicityOptions,
  updateSexualOrientationOptions,
  clearDemographicOptions,
} = demographicSlice.actions;

export default demographicSlice.reducer;


const getGenderOptions = (state: RootState) => state.demographic.genderOptions;
const getPronounOptions = (state: RootState) => state.demographic.pronounOptions;
const getEthnicityOptions = (state: RootState) => state.demographic.ethnicityOptions;
const getSexualOrientationOptions = (state: RootState) => state.demographic.sexualOrientationOptions;

// Memoized selectors that only recalculate when their inputs change
export const selectGenderDropdownOptions = createSelector(
  [getGenderOptions],
  (genderOptions) => transformToDropdownOptions(genderOptions)
);

export const selectPronounDropdownOptions = createSelector(
  [getPronounOptions],
  (pronounOptions) => transformToDropdownOptions(pronounOptions)
);

export const selectEthnicityDropdownOptions = createSelector(
  [getEthnicityOptions],
  (ethnicityOptions) => transformToDropdownOptions(ethnicityOptions)
);

export const selectSexualOrientationDropdownOptions = createSelector(
  [getSexualOrientationOptions],
  (sexualOrientationOptions) => transformToDropdownOptions(sexualOrientationOptions)
);